"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyChunk = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyChunk(factory, src, chunkSize) {
    if (chunkSize <= 0) {
        throw new Error('chunkSize must be greater than 0');
    }
    function* generator() {
        let chunk = [];
        for (const item of src) {
            chunk.push(item);
            if (chunk.length >= chunkSize) {
                yield factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(chunk), chunk);
                chunk = [];
            }
        }
        if (chunk.length > 0) {
            yield factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(chunk), chunk);
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyChunk = applyChunk;
//# sourceMappingURL=applyChunk.js.map